import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import mutations from './mutations'
import actions from './actions'
import stateA from './modules/state_a'

Vue.use(Vuex)

// Request Base URL
// axios.defaults.baseURL = "https://www.17life.com/";  //for development
// axios.defaults.baseURL = "./"; //for production
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
axios.defaults.withCredentials = true;

export default new Vuex.Store({
  state: stateA.state,
  mutations: mutations.mutations,
  actions: actions.actions,
})
